const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimedVolts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M495.488 101.44c-.088-.256-.152-.504-.264-.752a7.998 7.998 0 0 0-1.6-2.344l-80-80a8.002 8.002 0 0 0-2.352-1.6c-.24-.104-.472-.168-.72-.256a7.666 7.666 0 0 0-2.12-.416c-.128.008-.272-.072-.432-.072H184c-4.389 0-8 3.611-8 8v152h16V32h208v72c0 4.389 3.611 8 8 8h72v320H312v16h176c4.389 0 8-3.611 8-8V104c0-.176-.088-.328-.104-.504a7.557 7.557 0 0 0-.408-2.056ZM416 96V43.312L468.688 96H416Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.08333 0 0 .08333 6.167 6.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 496h236c14.263 0 26-11.737 26-26 0-5.625-1.825-11.1-5.2-15.6L280 429.336V337.76c.219-43.034-27.588-81.528-68.512-94.84l19.712-39.344a7.998 7.998 0 0 0 .844-3.576c0-4.389-3.612-8-8-8H95.996c-4.388 0-8 3.611-8 8 0 1.241.289 2.466.844 3.576l19.672 39.344C67.588 256.232 39.781 294.726 40 337.76v91.576L21.2 454.4A26.003 26.003 0 0 0 16 470c0 14.263 11.737 26 26 26Zm169.056-288-16 32h-70.112l-16-32h102.112ZM34 464l20.4-27.2A8.004 8.004 0 0 0 56 432v-94.24c-.193-38.952 26.917-73.107 64.896-81.76h78.208c37.979 8.653 65.089 42.808 64.896 81.76V432c0 1.731.562 3.415 1.6 4.8L286 464c1.298 1.731 2 3.837 2 6 0 5.486-4.514 10-10 10H42c-5.486 0-10-4.514-10-10 0-2.163.702-4.269 2-6ZM328 72a64.416 64.416 0 0 1-38.4-12.8l-12.8-9.6a8.02 8.02 0 0 0-9.6 0l-12.8 9.6A64.416 64.416 0 0 1 216 72c-4.389 0-8 3.611-8 8v44.144c.016 20.075 10.8 38.671 28.216 48.656L268 190.944a8.008 8.008 0 0 0 7.936 0l31.848-18.144c17.416-9.985 28.2-28.581 28.216-48.656V80c0-4.389-3.611-8-8-8Zm-8 52.144a40.123 40.123 0 0 1-20.152 34.728L272 174.784l-27.848-15.912A40.123 40.123 0 0 1 224 124.144V87.592A80.638 80.638 0 0 0 264 72l8-6 8 6a80.638 80.638 0 0 0 40 15.592v36.552Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.08333 0 0 .08333 6.167 6.167)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(45, 169, 226)"
    },
    d: "M264 88h16v16h-16zM264 136h16v16h-16zM240 111.336h16v16h-16zM288 112h16v16h-16zM248 216h200v16H248zM280 256h80v16h-80zM376 256h72v16h-72zM368 176h80v16h-80zM368 136h80v16h-80z",
    transform: "matrix(.08333 0 0 .08333 6.167 6.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 151c24.813 0 45 20.187 45 45 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-41.355-33.645-75-75-75s-75 33.645-75 75v45h-15c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h15c-.267 1.404 3.046 35.742-25.606 64.393C145.976 344.81 152.646 361 166 361h150c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H196.061c16.632-29.578 14.798-58.837 14.939-60h45c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-45v-45c0-24.813 20.187-45 45-45Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.0463 0 0 .04496 7.885 26.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.624 197.408a10.677 10.677 0 0 0-9.28-5.408H264.611l23.426-178.995c.039-.372.059-.745.059-1.119 0-5.885-4.843-10.728-10.728-10.728a10.736 10.736 0 0 0-8.992 4.877L98.445 303.747a10.666 10.666 0 0 0-1.58 5.586c0 5.851 4.815 10.666 10.666 10.667h137.645l-18.565 179.264a10.63 10.63 0 0 0-.032.818c0 5.886 4.844 10.73 10.731 10.73 3.672 0 7.098-1.884 9.063-4.985l167.123-297.68a10.681 10.681 0 0 0 .128-10.739Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "translate(33.933 31.365) scale(.01635)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedVolts);
export default __webpack_public_path__ + "static/media/claimed-volts.2107d1e7b7551ebba27522bfa9e12461.svg";
export { ForwardRef as ReactComponent };